module.exports = __webpack_public_path__ + "img/slotmachine_normal_bg.7f99dfe3.png";